// import CompareTwin from './features/components/dashboard/LeftContainer/compareTwin';
// import Academy from "./features/components/Academy/AcademyDummy";
import DataManagement from "./features/components/dashboard/LeftContainer/data-management/dataManagement";
import UserManagement from "./features/components/dashboard/LeftContainer/userManagement";
import Dashboard from "./features/components/dashboard/dashboard";
import UserAssistance from "./features/components/header/userAssistance";
import Login from "./features/components/login/login";
import Logout from "./features/components/login/logout";
import RedirectLogin from "./features/components/login/redirectLogin";
import RedirectPage from "./features/components/login/redirectPage";
import VmConsole from "./features/components/wmks/VmConsole";
import ProtectedRoute from "./common/components/protected-route";
/*** ACADEMY ROUTES */
import ViewCourseList from "./features/components/academy/view-course-templates/view-course-list";
import CreateCourse from "./features/components/academy/create-course/create-course";
import ViewCourse from "./features/components/academy/view-course/view-course";
import StartCourseInstance from "./features/components/academy/start-course-instance/start-course-instance";
import IsoFileManagement from "./features/components/academy/iso-file-management/iso-file-management";
import FileManagement from "./features/components/academy/file-management/file-management";
import ViewDeployedCourseInstance from "./features/components/academy/view-deployed-course-instance/view-deployed-course-instance";
import CoursePermissionGuard from "./features/components/academy/common/components/course-permission-guard/course-permission-guard";

export const routesConfig = [
  {
    path: "/",
    element: <Login />,
    component: Login,
  },
  {
    path: "/none/login-callback",
    element: <RedirectPage />,
    component: RedirectPage,
  },
  {
    path: "/loginFailed",
    element: <RedirectLogin />,
    component: RedirectLogin,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    component: Dashboard,
  },
  {
    path: "/dashboard/dataManagement",
    element: <DataManagement />,
    component: DataManagement,
  },
  {
    path: "/dashboard/userManagement",
    element: <UserManagement />,
    component: UserManagement,
  },
  {
    path: "/dashboard/vmware/:siteId/:name",
    element: <VmConsole />,
    component: VmConsole,
  },
  {
    path: "/userAssistance",
    element: <UserAssistance />,
    component: UserAssistance,
  },
  {
    path: "/logout",
    element: <Logout />,
    component: Logout,
  },
  /** ACADEMY ROUTES */
  {
    path: "/academy/viewCourseTemplates",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <ViewCourseList />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/createCourse",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <CreateCourse />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/copycourse/:courseId",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <CreateCourse />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/editCourse/:courseId",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <CreateCourse />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/viewCourse/:courseDefintionID",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <ViewCourse />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/startCourseInstance",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <StartCourseInstance />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/editCourseInstance/:instanceId",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <StartCourseInstance />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/iso-file-management",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <IsoFileManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/file-management",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <FileManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/viewDeployedCourseInstance/:courseInstanceID",
    element: (
      <ProtectedRoute requireAcademyAccess={true}>
        <CoursePermissionGuard>
          <ViewDeployedCourseInstance />
        </CoursePermissionGuard>
      </ProtectedRoute>
    ),
  },
  // {
  //   path: "/userAssistance/AcademyAdmin",
  //   element: <UserAssistance />,
  //   component: UserAssistance,
  // },
  {
    path: "/userAssistance/Content/Academy",
    element: <UserAssistance />,
    component: UserAssistance,
  },
];
